const API = `${window.location.origin}/backend`;

export const getProjects = () =>
  fetch(`${API}/list_folders.php`)
    .then(r => r.json());

export const getFiles = (project) =>
  fetch(`${API}/list_files.php?project=${encodeURIComponent(project)}`)
    .then(r => r.json());

export const getFile = (project, file) =>
  fetch(`${API}/get_file.php?project=${encodeURIComponent(project)}&file=${encodeURIComponent(file)}`)
    .then(r => r.text());
